module.exports = __webpack_public_path__ + "static/media/logo.8534de3f.svg";